import {
	applyAppointmentCatalogSelects,
	bindAppointmentCatalogSelectSync,
} from './appointment-form-prefill';
import { syncTomSelectFromNative } from './site-modal-selects';
import { loadFlatpickrRu } from '../utils/load-flatpickr-ru';

/**
 * Appointment modal: input masks and optional date field (CF7 markup is managed in admin).
 *
 * @return {void}
 */
export function initAppointmentModal() {
	const modal = document.querySelector('[data-modal="appointment"]');

	if (!modal) {
		return;
	}

	bindAppointmentCatalogSelectSync(modal);

	const i18n = window.lecardoVeinModals?.i18n || {};

	const initInputMasks = () => {
		if (!window.Input) {
			return;
		}

		const inputs = modal.querySelectorAll(
			'input:not([data-input-initialized]):not([name="appointment-date"])'
		);

		if (!inputs.length) {
			return;
		}

		inputs.forEach((input) => {
			input.dataset.inputInitialized = 'true';
		});

		new window.Input().listenner(Array.from(inputs));
	};

	const initAppointmentDatePicker = async () => {
		const input = modal.querySelector('input[name="appointment-date"]');

		if (
			!input ||
			input._flatpickr ||
			input.closest('[hidden]') ||
			!input.isConnected
		) {
			return;
		}

		const fieldLabel = input.closest('label');

		if (fieldLabel && 'none' === window.getComputedStyle(fieldLabel).display) {
			return;
		}

		const placeholder =
			input.getAttribute('placeholder') ||
			i18n.datePlaceholder ||
			'Appointment date';

		input.type = 'text';
		input.setAttribute('placeholder', placeholder);
		input.setAttribute('autocomplete', 'off');
		input.dataset.inputInitialized = 'true';

		const { flatpickr, Russian } = await loadFlatpickrRu();

		if (input._flatpickr) {
			return;
		}

		const picker = flatpickr(input, {
			dateFormat: 'Y-m-d',
			allowInput: true,
			disableMobile: true,
			locale: Russian,
			minDate: 'today',
			onOpen(_selectedDates, _dateStr, instance) {
				instance._positionCalendar();
			},
		});

		if ('true' !== modal.dataset.appointmentDateScrollBound) {
			modal.dataset.appointmentDateScrollBound = 'true';

			modal.addEventListener(
				'scroll',
				() => {
					if (picker.isOpen) {
						picker._positionCalendar();
					}
				},
				{ passive: true }
			);
		}
	};

	const syncModalSelects = () => {
		modal.querySelectorAll('select.form-select').forEach((select) => {
			if (select instanceof HTMLSelectElement) {
				syncTomSelectFromNative(select);
			}
		});
	};

	/**
	 * @param {{ specialistId?: string|null, serviceId?: string|null }|undefined} detail
	 * @return {void}
	 */
	const prepareAppointmentForm = (detail) => {
		applyAppointmentCatalogSelects(modal, detail);
		void initAppointmentDatePicker();
		initInputMasks();
		syncModalSelects();
	};

	document.addEventListener('lecardo-vein:modal:open', (event) => {
		if ('appointment' !== event.detail?.modalId) {
			return;
		}

		prepareAppointmentForm(event.detail);
	});
}
